(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eb-measuring-guides"]) return;
  try {
    
const root=document.getElementById('eb-measuring');if(root){root.querySelectorAll('[data-fit]').forEach(button=>button.addEventListener('click',()=>{root.querySelectorAll('[data-fit]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));root.querySelectorAll('[data-panel]').forEach(p=>p.hidden=p.dataset.panel!==button.dataset.fit)}));}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eb-slats-grid"]) return;
  try {
    document.addEventListener('change',function(event){if(!event.target.matches('[data-eb-slat-filter]'))return;const url=new URL(window.location.href);url.searchParams.delete('page');url.searchParams.delete(event.target.name);if(event.target.value)url.searchParams.append(event.target.name,event.target.value);window.location.assign(url.toString());});
  } catch(e) { console.error(e); }
})();
})();
